export default "__VITE_ASSET__C4QP7OA1__"